import firebase from 'firebase/app'

export const useCommunity = () => {
  const identifyCommunityUser = async () => {
    const isLocal = process.env.NODE_ENV === 'development'
    const serverUrl = isLocal
      ? 'http://localhost:8080'
      : process.env.REACT_APP_SERVER_URL?.split('/graphql')[0]

    const tokenResult = await firebase.auth().currentUser?.getIdTokenResult()

    if (!tokenResult?.token) {
      return
    }

    await fetch(`${serverUrl}/community/identify`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${Buffer.from(tokenResult.token).toString('base64')}` }
    })
  }

  return { actions: { identifyCommunityUser } }
}
